import { render, staticRenderFns } from "./Lamp.vue?vue&type=template&id=4afff5b0&scoped=true"
import script from "./Lamp.vue?vue&type=script&lang=js"
export * from "./Lamp.vue?vue&type=script&lang=js"
import style0 from "./Lamp.vue?vue&type=style&index=0&id=4afff5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afff5b0",
  null
  
)

export default component.exports